import type { DeepPartial } from '@/config'
import type { Config } from './config.type'
import domain from './domain'

const NGROK_DOMAIN = 'https://34aa-84-69-246-4.eu.ngrok.io'

const isLocal =
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('ngrok.io')
const localAuthDomain = window.location.hostname.includes('ngrok.io')
  ? NGROK_DOMAIN
  : window.location.origin

const useProd = false
const config: DeepPartial<Config> = {
  appName: 'Stampede Product',
  url: {
    selfservice: `https://api-selfservice.stg.${domain}`,
    api: `https://api${useProd ? '' : '.stage'}.${domain}`,
    // api: `http://localhost:8080`,
    connect: isLocal
      ? localAuthDomain
      : `https://product${useProd ? '' : '.stage'}.${domain}`,
    accounts: `https://accounts${useProd ? '' : '.stage'}.${domain}`,
    nearly: `https://wifi.stage.${domain}`,
    mailchimp: `https://mailchimp.stage.${domain}`,
    reviews: `https://reviews${useProd ? '' : '.stage'}.${domain}`,
    calculator: '//localhost:3006/pricing/calc',
    service: `https://service${useProd ? '.prd' : '.stg'}.${domain}`,
    cypher: `https://cypher${useProd ? '.prd' : '.stg'}.${domain}`,
    forms: `https://forms${useProd ? '' : '.stage'}.stampede.ai`,
    urlGenerator: `https://url-generator.${useProd ? 'prd' : 'stg'}.${domain}`,
    bookingIntegration: `https://bookings-intergrations.${
      useProd ? 'prd' : 'stg'
    }.${domain}`,
    bookings: `https://api-bookings${useProd ? '.prd' : '.stg'}.${domain}`,
    booking_url: `https://booking${useProd ? '' : '.stage'}.stampede.ai`,
    ordering_url: `https://ordering${useProd ? '' : '.stage'}.stampede.ai`,
    gifting: `https://gifting.stage.${domain}`,
    reporting: `https://reporting.stg.${domain}`,
    inbox_email: `@${useProd ? '' : 'stage.'}stmpd-mail.com`,
    inbox: `https://inbox${useProd ? '.prd' : '.stg'}.${domain}`,
    //inbox: `http://localhost:8082`,
    morpheus: `https://morpheus${useProd ? '.prd' : '.stg'}.${domain}`,
    //morpheus: `http://localhost:8080`,
    neo: `https://neo${useProd ? '.prd' : '.stg'}.${domain}`,
    //neo: `http://localhost:8081`,
    zion: `https://zion.stg.stampede.ai`,
    //zion: `http://localhost:8080`,
    operator: `https://operator.stg.stampede.ai`,
    voiceWs: `wss://sbc-ws.stg.stampede.ai`,
    voiceDemoNumber: '+447000000001',

    // agent_smith: `https://agent-smith${useProd ? '.prd' : '.stg'}.${domain}`,
    agent_smith: `http://localhost:8081`,
    loyalty: `https://loyalty${useProd ? '.prd' : '.stg'}.${domain}`,
    trinity: `https://trinity${useProd ? '.prd' : '.stg'}.${domain}`,
    auth: `https://auth${useProd ? '' : '.stage'}.${domain}`,
    integrations: `https://bookings-intergrations${
      useProd ? 'prd' : '.stg'
    }.${domain}`,
    reports: `https://reports-api.stg.${domain}`,
    sites: `https://sites.stage.${domain}`,
    tank: `https://tank${useProd ? '.prd' : '.stg'}.${domain}`,
    // tank: `http://localhost:8008`,
    vpn: `https://vpn${useProd ? '' : '.stage'}.${domain}`,
    trunk: `https://trunk.stg.stampede.ai`,
    //trunk: `http://localhost:4111`,
    eve: `https://eve.agent.stampede.ai`,
    // Mouse (ordering). Stage, like every other service in this file, because
    // `config/index.ts` maps BOTH `staging` and `preview` to this config: a
    // localhost URL here is not a local-dev convenience, it is what the
    // deployed stage build asks the browser to call, and Connect's ordering
    // gate fails closed, so the whole Ordering section silently disappears.
    // Uncomment the localhost line to run against a local Mouse (`make dev` in
    // ~/Code/mouse), the same way `tank` and `trunk` above are handled.
    mouse: `https://mouse.stg.${domain}`,
    //mouse: `http://localhost:3005`,
  },
  auth: {
    clientId: isLocal ? 'connect_react_stage' : `${domain}.connect_stage`,
    redirectUri: `${localAuthDomain}/code`,
  },
  apiOauth: {
    clientId:
      '348453694666-6ttcbmf9bb6b0e69jr1s0qgmehb10n6a.apps.googleusercontent.com',
    redirectUri: `${localAuthDomain}/oauth/google/callback`,
  },
  enableWhyDidYouUpdate: false,
}

export default config
